import { useEffect, useState } from "react";
import { LOGO_URL } from "../lib/assets";

/**
 * Initial loading splash — shows the Trust Flooring & Interiors logo
 * with a subtle entrance, holds for a beat, then fades away revealing
 * the site. Renders once per page load.
 */
export default function SplashIntro({ duration = 1800, fadeMs = 700 }) {
  const [stage, setStage] = useState("visible"); // visible | fading | gone

  useEffect(() => {
    // Lock body scroll while splash is up
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const fadeTimer = setTimeout(() => setStage("fading"), duration);
    const goneTimer = setTimeout(() => {
      setStage("gone");
      document.body.style.overflow = original;
    }, duration + fadeMs);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(goneTimer);
      document.body.style.overflow = original;
    };
  }, [duration, fadeMs]);

  if (stage === "gone") return null;

  return (
    <div
      data-testid="splash-intro"
      aria-hidden="true"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#111111]"
      style={{
        opacity: stage === "fading" ? 0 : 1,
        transition: `opacity ${fadeMs}ms cubic-bezier(0.22, 1, 0.36, 1)`,
        pointerEvents: stage === "fading" ? "none" : "auto",
      }}
    >
      <img
        src={LOGO_URL}
        alt="Trust Flooring & Interiors"
        className="h-32 md:h-44 w-auto splash-logo"
      />
    </div>
  );
}
